import { render, staticRenderFns } from "./mobilePage.vue?vue&type=template&id=a0579a18&scoped=true&"
import script from "./mobilePage.vue?vue&type=script&lang=js&"
export * from "./mobilePage.vue?vue&type=script&lang=js&"
import style0 from "./mobilePage.vue?vue&type=style&index=0&id=a0579a18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0579a18",
  null
  
)

export default component.exports